import { LabelOption, Label } from '@uds/label';
import { Panel } from '@uds/panel';
import { cx } from 'linaria';
import './radio.stylesheet_55r5np.css';
import { jsx, jsxs } from 'react/jsx-runtime';
import { Children } from 'react';
import './multiradio.stylesheet_sudzbg.css';

const root$1 = {
  default: "d14p8w1p",
  panel: "pkaiau",
  readOnly: "r14q4c82",
  disabled: "d8m3pch",
  error: "egccxio"
};
const input = {
  default: "dip1pxx",
  readOnly: "rybz5yu",
  disabled: "d1vq4idl"
};
const radio = {
  default: "dytyc99",
  checked: "ck3asz",
  disabled: "d1aivmbr",
  disabledChecked: "dvsvj1m"
};
const getClassNames$1 = props => {
  return {
    root: cx(root$1.default, !props.multi && root$1.panel, props.readOnly && root$1.readOnly, props.disabled && root$1.disabled, props.error && props.multi !== true && root$1.error),
    input: cx(input.default, props.readOnly && input.readOnly, props.disabled && input.disabled),
    radio: cx(radio.default, props.checked && radio.checked, (props.disabled || props.readOnly) && radio.disabled, (props.disabled || props.readOnly) && props.checked && radio.disabledChecked)
  };
};

const Radio = _ref => {
  let {
    id = '',
    label,
    hint,
    value,
    name,
    checked = false,
    disabled = false,
    readOnly = false,
    multi = false,
    error = false,
    onChange = () => null
  } = _ref;
  const classNames = getClassNames$1({
    checked,
    disabled,
    readOnly,
    multi,
    error
  });
  return /*#__PURE__*/jsx(Panel, {
    className: classNames.root,
    children: /*#__PURE__*/jsxs(LabelOption, {
      htmlFor: id,
      disabled: disabled,
      readOnly: readOnly,
      hint: hint,
      children: [/*#__PURE__*/jsx("input", {
        id: id,
        type: "radio",
        value: value,
        name: name,
        className: classNames.input,
        checked: checked,
        disabled: disabled,
        readOnly: readOnly,
        onChange: onChange
      }), /*#__PURE__*/jsx("span", {
        className: classNames.radio
      }), label]
    })
  });
};
var Radio$1 = Radio;

const root = {
  default: "d1i5wl7w"
};
const panel = {
  default: "dlqkv7b",
  readOnly: "r5qx2kp",
  disabled: "d1onc1wq",
  error: "e131d35i"
};
const getClassNames = props => {
  return {
    root: root.default,
    panel: cx(panel.default, props.readOnly && panel.readOnly, props.disabled && panel.disabled, props.error && panel.error)
  };
};

const MultiRadio = _ref => {
  let {
    children,
    label,
    disabled = false,
    readOnly = false,
    error = false
  } = _ref;
  const classNames = getClassNames({
    disabled,
    readOnly,
    error
  });
  return /*#__PURE__*/jsxs("fieldset", {
    className: classNames.root,
    children: [/*#__PURE__*/jsx(Label, {
      as: "legend",
      children: label
    }), /*#__PURE__*/jsx(Panel, {
      className: classNames.panel,
      children: Children.map(children, option => /*#__PURE__*/jsx(option.type, {
        ...option.props,
        disabled: disabled,
        readOnly: readOnly,
        error: error === true ? true : undefined,
        multi: true
      }))
    })]
  });
};
var MultiRadio$1 = MultiRadio;

export { MultiRadio$1 as MultiRadio, Radio$1 as Radio };
